"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PulseOptionNames;
(function (PulseOptionNames) {
    PulseOptionNames["embed"] = "embed";
    PulseOptionNames["token"] = "token";
    PulseOptionNames["disableExploreFilter"] = "disableExploreFilter";
    PulseOptionNames["layout"] = "embed_layout";
    PulseOptionNames["theme"] = "embed_theme";
    PulseOptionNames["ApiExternalVersion"] = ":apiExternalVersion";
    PulseOptionNames["ApiInternalVersion"] = ":apiInternalVersion";
    PulseOptionNames["PulseWebComponent"] = ":pulseWebComponent";
})(PulseOptionNames = exports.PulseOptionNames || (exports.PulseOptionNames = {}));
//# sourceMappingURL=PulseInterface.js.map